import { Share2, Check } from 'lucide-react'
import { useState } from 'react'
import { jsBridge } from '@/lib/js-bridge'
import { analytics } from '@/lib/analytics'
import { prepareShareContent } from '@/lib/utils'

interface ShareAnswerButtonProps {
	answerText: string
}

export default function ShareAnswerButton({ answerText }: ShareAnswerButtonProps) {
	const [shareState, setShareState] = useState<'default' | 'success'>('default')

	const handleShare = async () => {
		const shareContent = prepareShareContent(answerText)

		if (window.isReactNativeApp) {
			jsBridge.shareContent({ text: shareContent })
			analytics.answerShared('native')
			setShareState('success')
			setTimeout(() => setShareState('default'), 1500)
			return
		}

		if (navigator.share) {
			try {
				await navigator.share({
					title: 'TutorCat Solution',
					text: shareContent,
				})
				analytics.answerShared('web_share')
				setShareState('success')
				setTimeout(() => setShareState('default'), 1500)
			} catch (error) {
				if (error instanceof Error && error.name !== 'AbortError') {
					console.error('Share failed:', error)
					fallbackCopyToClipboard(shareContent)
				}
			}
		} else {
			fallbackCopyToClipboard(shareContent)
		}
	}

	const fallbackCopyToClipboard = (content: string) => {
		navigator.clipboard.writeText(content).then(() => {
			analytics.answerShared('clipboard')
			setShareState('success')
			setTimeout(() => setShareState('default'), 1500)
		}).catch((error) => {
			console.error('Clipboard copy failed:', error)
		})
	}

	return (
		<button
			onClick={handleShare}
			className='flex items-center gap-1 px-2 py-1 opacity-80 hover:opacity-100 transition-opacity'
			title='Share answer'
		>
			{shareState === 'success'
				? <Check size={16} className='m-0 opacity-100' />
				: <Share2 size={16} className='m-0 opacity-80 cursor-pointer' />}
		</button>
	)
}
